/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Profile_Cultureandvalues_Placeholder2Inputs */

const en_company_profile_cultureandvalues_placeholder2 = /** @type {(inputs: Company_Profile_Cultureandvalues_Placeholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type here…`)
};

const de_company_profile_cultureandvalues_placeholder2 = /** @type {(inputs: Company_Profile_Cultureandvalues_Placeholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hier tippen…`)
};

/**
* | output |
* | --- |
* | "Type here…" |
*
* @param {Company_Profile_Cultureandvalues_Placeholder2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const company_profile_cultureandvalues_placeholder2 = /** @type {((inputs?: Company_Profile_Cultureandvalues_Placeholder2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Profile_Cultureandvalues_Placeholder2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_profile_cultureandvalues_placeholder2(inputs)
	return en_company_profile_cultureandvalues_placeholder2(inputs)
});
export { company_profile_cultureandvalues_placeholder2 as "company_profile_cultureAndValues_placeholder" }